<div class="department-details">
  <h2 *ngIf="department.value.id !== 0 || editMode">
    <span id="icon" class="material-icons-outlined">apartment</span>
    <span class="title-details">{{ departmentTitle | translate }}</span>
  </h2>

  <div *ngIf="DepartmentEmpty()" class="empty-details">
    <span class="material-icons-outlined">apartment</span>
  </div>

  <div
    *ngIf="department.value.id !== 0 || editMode"
    class="department-info-container"
  >
    <div *ngIf="department.value.id !== 0 && !editMode" class="department-info">
      <table>
        <tr>
          <td>
            <strong>{{ "departmentDetails.nameLabel" | translate }}:</strong>
          </td>
          <td>{{ department.value.name }}</td>
        </tr>
      </table>

      <div *ngIf="supervisor" class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "departmentDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteDepartment()">
          <span class="material-icons-outlined">delete</span>
          {{ "departmentDetails.deleteButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="departmentForm"
        [messagesObserver]="messages"
        fieldname="department"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="TRUE"
      ></messages>
      <department-user
        [currentDepartmentId]="currentDepartmentId"
      ></department-user>
    </div>

    <form [formGroup]="departmentForm" *ngIf="editMode">
      <div class="form-group">
        <label for="name"
          >{{ "departmentDetails.nameLabel" | translate }}:</label
        >
        <input type="text" id="name" formControlName="name" />
        <messages
          class="msg"
          [form]="departmentForm"
          [messagesObserver]="messages"
          fieldname="name"
        ></messages>
      </div>
      <div class="action-buttons">
        <action-button
          (actionEvent)="saveDepartment($event)"
          label="{{ 'departmentDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "departmentDetails.saveButton" | translate }}
        </action-button>

        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "departmentDetails.cancelButton" | translate }}
        </button>
      </div>

      <messages
        class="message"
        [form]="departmentForm"
        [messagesObserver]="messages"
        fieldname="department"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="TRUE"
      ></messages>
    </form>
  </div>
</div>
